  <router-outlet></router-outlet>
  <div class="dashboard-tx flex flex-col items-center justify-center sticky top-[90px] z-[1029] 
  -translate-y-[24px] pt-2 pb-1 w-full" 
  style="background-color: white; 
  box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.2);">
  
  <div class="text-center w-full">
    <h1 class="text-xl font-medium mb-1 text-[#003366] text-center">
      {{ currentLanguage === 'vi' ? 'UCOD Việt Nam' : 'UCOD Vietnam' }}
    </h1>
    <h4 class="text-sm text-center" style="margin-bottom: 0px;">
      {{ currentLanguage === 'vi' ? 'Chọn nguyên nhân tử vong chính (UCOD)' : 'Select the underlying cause of death (UCOD)' }}
    </h4>
  </div>

  <div class="topcorner flex justify-end  w-full absolute top-1 right-0 pr-4" style="flex-direction:row">
    <button type="button" class="btn btn-primary btn-sm" (click)="openModal()">Phiên bản 3.0</button>
    <button type="button" id="languageToggleButton" class="btn btn-secondary btn-sm ml-2" (click)="toggleLanguage()">
      {{ currentLanguage === 'vi' ? 'English' : 'Tiếng Việt' }}
    </button>
  </div>
</div>




  <div class="container" style="margin-top: 20px; display: flex;">
    
    <div style="width: 40%; margin: 0 auto;">
    <div class="row left-section" style="border: 1px solid #000000; background-color: #f9f2ff; border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-left: 40px;padding-right: 20px;padding-bottom: 25px; width: 100%;">
      <form class="margin"(ngSubmit)="onSubmit()">
        <h3><b>{{ currentLanguage === 'vi' ? 'Phiếu chẩn đoán nguyên nhân tử vong' : 'Cause of Death Diagnosis Form' }}</b></h3>

      
        <div class="row sex-age" style="border-top: 1px solid #000000; padding-top: 10px; display: flex; justify-content: space-between; margin-bottom: 10px; width: 100%;">
          <div class="sex" style="width: 48%; display: flex; align-items: center;">
            <b>{{ currentLanguage === 'vi' ? 'Giới: ' : 'Gender: ' }}</b>
            <select name="sex" [(ngModel)]="sex" class="form-control" style="margin-left: 10px; width: 50%; padding: 5px; font-size: 14px; text-align: center;">
              <option value="" disabled selected>{{ currentLanguage === 'vi' ? 'Không' : 'No' }}</option>
              <option value="Không xác định">{{ currentLanguage === 'vi' ? 'Không xác định' : 'Not specified' }}</option>
              <option value="Nam">{{ currentLanguage === 'vi' ? 'Nam' : 'Male' }}</option>
              <option value="Nữ">{{ currentLanguage === 'vi' ? 'Nữ' : 'Female' }}</option>
            </select>
          </div>

          <div class="age" style="width: 48%; display: flex; align-items: center;">
            <b>{{ currentLanguage === 'vi' ? 'Tuổi: ' : 'Age: ' }}</b>
            <input type="number" [(ngModel)]="age" name="age" min="1" max="50000" class="form-control" style="margin-left: 10px; padding: 5px; font-size: 14px; width: 50%;">
            <select name="ageUnit" [(ngModel)]="ageUnit" class="form-control" style="text-align: center;margin-left: 10px; padding: 5px; width: 50%;">
              <option value="y">{{ currentLanguage === 'vi' ? 'năm' : 'years' }}</option>
              <option value="m">{{ currentLanguage === 'vi' ? 'tháng' : 'months' }}</option>
              <option value="d">{{ currentLanguage === 'vi' ? 'ngày' : 'days' }}</option>
            </select>
          </div>
        </div>

        <!-- Phần I -->
        <div class="row" style="border-top: 1px solid #000000; padding-top: 10px; display: flex; margin-bottom: 10px; width: 100%;">
          <div class="part" style="width: 50%;">
            <p><b>{{ currentLanguage === 'vi' ? 'Phần I' : 'Part I' }}</b></p>
            <p style="font-size: 14px;">
              {{ currentLanguage === 'vi' ? 'Dòng đầu, chứa các mã bệnh hoặc bệnh lý trực tiếp dẫn tới tử vong...' : 'The first line contains codes for diseases or conditions directly leading to death...' }}
            </p>
          </div>
          <div class="input-area" style="width: 50%;">
            <textarea  [(ngModel)]="partI" (ngModelChange)="onCodesIChange()" name="partI" class="textwrapper form-control" placeholder="{{ currentLanguage === 'vi' ? 'Nhập mã bệnh' : 'Enter disease codes' }}" id="liveboxI" rows="5" style="width: 100%; padding: 10px; font-size: 14px;"></textarea>
          </div>
        </div>

        <!-- Phần II -->
        <div class="row" style="border-top: 1px solid #000000; padding-top: 10px; display: flex; margin-bottom: 10px; width: 100%;">
          <div class="part" style="width: 50%;">
            <b>{{ currentLanguage === 'vi' ? 'Phần II' : 'Part II' }}</b>
            <p style="font-size: 14px;">
              {{ currentLanguage === 'vi' ? 'Các mã bệnh, điều kiện đáng kể khác góp phần gây tử vong...' : 'Codes for diseases or other significant conditions contributing to death...' }}
            </p>
          </div>
          <div class="input-area" style="width: 50%;">
            <input type="text" [(ngModel)]="partII" (ngModelChange)="onCodesIIChange()" name="partII" id="liveboxII" placeholder="{{ currentLanguage === 'vi' ? 'Nhập mã bệnh' : 'Enter disease codes' }}" class="form-control" style="width: 100%; padding: 10px; font-size: 14px;">
          </div>
        </div>

        <!-- Action Row -->
        <div class="row action-row" style="display: flex; align-items: center; margin-top: 10px; width: 100%;">
          <div class="warning" style="flex: 1; display: flex; justify-content: flex-end; padding-right: 10px;">
            <b style="white-space: nowrap;margin-right: 15px">{{ currentLanguage === 'vi' ? 'Chú ý: ' : 'Note: ' }}</b> {{ currentLanguage === 'vi' ? 'Các mã bệnh cách nhau bởi khoảng trống và có thể nhập mã bỏ qua dấu chấm.' : 'Disease codes are separated by spaces and can be entered without periods.' }}
          </div>
          <button type="submit" id="buttonRun" class="btn-primary1" style="background-color: #007bff; height: 45px;margin: 10px; width: 130px; border: 1px solid #0056b3; border-radius: 5px; color: white;">
            {{ currentLanguage === 'vi' ? 'Chẩn đoán UCOD' : 'Diagnose UCOD' }}
          </button>
        </div>
      </form>
    </div>
    <div #scrollContainer class="scrollable-table" (mousedown)="startDragging($event)" 
    (mouseleave)="stopDragging()" 
    (mouseup)="stopDragging()" 
    (mousemove)="onMouseMove($event)" style="margin-top:20px">
  <div class="column1" [innerHTML]="tablerela"></div>
</div>
    <!-- <div style="width: 100%; position: relative; z-index: 1;">
      <div class="column1"  [innerHTML]="tablerela"></div>
      </div> -->
    </div>
  
    <!-- Right Section -->
    <div class="right-section" style="margin-left: 20px; padding: 10px; width: 60%;">
      <div class="result-section">
        <h3><b style="
          /* font-size: 25px; */
          font-weight: 700;
          font-size: 25px"> {{ currentLanguage === 'vi' ? ' Chẩn đoán Nguyên nhân tử vong chính- UCOD' : ' Diagnosis of Underlying Cause of Death - UCOD.' }}</b>
          
        </h3>

        <p style="margin-top: 30px;"><b >{{ currentLanguage === 'vi' ? '1. Phiếu chẩn đoán nguyên nhân tử vong' : '1. Cause of Death Diagnosis Form' }}</b></p>
        <p style="margin-top: 35px;">Giới tính: <b>{{ sex|| 'Không xác định' }}</b></p>
        <p>Tuổi: <b>{{ age || 'Không xác định'}} {{ ageUnit === 'y' ? 'năm' : ageUnit === 'm' ? 'tháng' : 'ngày' }} </b></p>
      </div> 

      <table [class.table-section]="isActive" [innerHTML]="tablesection"style="width: 98%;
      margin: 0 auto;
      border-collapse: collapse;
      text-align: left;
      height: 100px" ></table>
      <!-- class="table-section mystyle -->
 
<!-- 
      <div style="width: 100%; position: relative; z-index: 1; overflow-x: auto; white-space: nowrap; top: 30px;">
        <div class="column1"  [innerHTML]="tablerela"></div>
        </div> -->
          <!-- <div #scrollContainer class="scrollable-table" (mousedown)="startDragging($event)" 
      (mouseleave)="stopDragging()" 
      (mouseup)="stopDragging()" 
      (mousemove)="onMouseMove($event)" style="margin-top:20px">
    <div class="column1" [innerHTML]="tablerela"></div>
  </div> -->




               
      <div class="result-section" style="
      margin-top: 24px; 
      padding: 16px 20px;
      border-radius: 8px; 
      background: #f8f9fa; /* Xám nhạt dịu mắt */
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08); /* Đổ bóng nhẹ */
  ">
      <h3 style="
          font-size: 18px;
          font-weight: bold;
          color: #333;
          margin-bottom: 8px;
          border-left: 4px solid #6c757d; /* Thanh sọc màu xám đậm */
          padding-left: 12px;
      ">
          {{ currentLanguage === 'vi' ? '2. Kết luận' : '2. Conclusion' }}
      </h3>
  
      <p style="
          font-size: 16px;
          color: #444;
          line-height: 1.6;
          margin: 0;
      ">
          <span style="
              display: block;
              background: #e9ecef;
              padding: 10px;
              border-radius: 6px;
              font-size: 18px;
              font-weight: bold;
              color: #495057; 
          ">
              {{ conclusion }}
          </span>
      </p>
  </div>
  <div class="result-section">
    <div class="column" style="width: 100% ;padding-top: 40px; font-size: 18px;
    
    margin-bottom: 12px;
    
    padding-left: 12px; padding-bottom: 30px;">  
    
    <b style=" font-weight: bold;">{{ currentLanguage === 'vi' ? '3. Diễn giải' : '3. Explanation' }}</b>
      
      <div class="margintb " [innerHTML]="table"style="margin-top: 20px;    width: 100%;
      font-size: 11pt;
      font-family: Arial;
      border-collapse: collapse;" >
        <table border="1" class="dataframe mystyle" style="width: 100%; border-collapse: collapse;"></table>
      </div>
    
  </div>
  </div>

    </div>
  </div>